import { SENTIMENT_META } from '../utils/sentiment.js';

// 5-point sentiment badge (prompt 53). Color comes from SENTIMENT_META so the
// badge, trend chart, and reports stay in sync. Pass `score` to append "— N/5".
export default function SentimentBadge({ value, score }) {
  const meta = SENTIMENT_META[value];
  if (!meta) {
    return <span className="badge badge--neutral">unknown</span>;
  }
  const label = score != null ? `${meta.label} — ${score}/5` : meta.label;
  return (
    <span className="badge" style={{ background: meta.color, color: '#fff' }}>
      {label}
    </span>
  );
}
